import { TableRow, TableRowProps } from "@mui/material";
import { useTheme } from "@mui/material/styles";

interface Props extends TableRowProps {
  children: React.ReactNode;
  rowIsHovered?: boolean;
}
const CustomTableRow = ({ children, rowIsHovered, ...props }: Props) => {
  const theme = useTheme();
  return (
    <TableRow
      {...props}
      sx={{
        "&:last-child td, &:last-child th": { border: 0 },
        height: "102px",
        minHeight: "102px",
        cursor: "pointer",
        bgcolor: rowIsHovered ? "action.hover" : "inherit",
        transition: theme.transitions.create(["background-color"], {
          duration: theme.transitions.duration.standard,
          easing: theme.transitions.easing.easeInOut,
        }),
        ...props.sx,
      }}
    >
      {children}
    </TableRow>
  );
};

export default CustomTableRow;
